import type { ChartPrice } from "epsm-api-types/models";

export const getLatestPrice = (data: ChartPrice[] = []): number | null => {
	const validData = data?.filter((d) => d?.date != null);
	if (validData.length === 0) return null;

	const sorted = [...validData].sort(
		(a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
	);

	const latestPrice = sorted[0]?.price;
	return latestPrice != null ? latestPrice : null;
};
